import { useMemo, useState, useCallback } from "react";

export default function useInventoryItemsFilter(items) {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredItems = useMemo(() => {
    if (!searchTerm.trim()) {
      return items;
    }

    const searchLower = searchTerm.toLowerCase().trim();
    
    return items.filter(item => {
      const asset = item.asset;
      if (!asset) return false;

      const itemId = asset.itemId?.toString().toLowerCase() || "";
      const barcode = asset.barcode?.toLowerCase() || "";
      const skuNumber = asset.skuNumber?.toLowerCase() || "";
      const description = asset.description?.toLowerCase() || "";

      return (
        itemId.includes(searchLower) ||
        barcode.includes(searchLower) ||
        skuNumber.includes(searchLower) ||
        description.includes(searchLower)
      );
    });
  }, [items, searchTerm]);

  const handleSearchChange = useCallback(event => {
    setSearchTerm(event.target.value);
  }, []);

  const clearSearch = useCallback(() => {
    setSearchTerm("");
  }, []);

  return {
    searchTerm,
    filteredItems,
    handleSearchChange,
    clearSearch,
  };
} 